import { ColorPicker, Form, Radio } from "antd";
import React from "react";
import { AttrViewCompName } from "src/common/attrView";
import { ZModeObjectRef } from "src/common/attrView/componentsDefs";
import { obj2LabelValue } from "src/common/attrView/obj2LabelValue";

const labelMap: Record<ZModeObjectRef, string> = {
  standart: "Обычный",
  tag: "Тэги",
  link: "Ссылки",
};

export const options = obj2LabelValue(labelMap);

type PropsObjectRefViewInfo = {
  curView: AttrViewCompName | undefined;
  stylesNameFn: (name: string) => string[];
};

export const ObjectRefViewInfo: React.FC<PropsObjectRefViewInfo> = ({
  curView,
  stylesNameFn,
}) => {
  const mode: ZModeObjectRef = Form.useWatch(stylesNameFn("mode"));
  const isObjectRef = curView === "ObectRef";

  if (!isObjectRef) return null;

  return (
    <>
      <Form.Item label="Мод" name={stylesNameFn("mode")}>
        <Radio.Group>
          {options.map(({ label, value }) => (
            <Radio.Button key={value} value={value}>
              {label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </Form.Item>
      {mode === "tag" && (
        <Form.Item
          label="цвет тэга"
          name={[...stylesNameFn("modeMeta"), "tagColor"]}
          getValueFromEvent={(e) => `#${e.toHex()}`}
        >
          <ColorPicker format="hex" />
        </Form.Item>
      )}
    </>
  );
};
